import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';
import useStore from '@/utils/store/common';
import Notification from '@/components/common/Notification/Notification.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddBookmarkDialog',
  props: {
  filters: {
    type: Array as PropType<{ [key: string]: any }[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const store = useStore();

const dialog = ref(false);
const valid = ref(false);
const bookmarkName = ref('');

const notificationContent = ref('');
const notificationStatus = ref('');
const isNotificationOpen = ref(false);



function close() {
  dialog.value = false;
}

async function saveBookmark() {
  const mergedFilters = Object.assign({}, ...props.filters);
  const stringFilters = JSON.stringify(mergedFilters);
  const filters = { filterGroup: { filters: stringFilters, name: bookmarkName.value } };
  const res = await store.dispatch('groupManagement/createFilterGroup', filters);
  store.dispatch('groupManagement/fetchFilterGroups');
  dialog.value = false;
  notificationStatus.value = res.notificationStatus;
  notificationContent.value = res.notificationStatus;
  isNotificationOpen.value = true;
}

function closeNotification() {
  isNotificationOpen.value = false;
  notificationContent.value = '';
  notificationStatus.value = '';
}

return { __sfc: true,store, dialog, valid, bookmarkName, notificationContent, notificationStatus, isNotificationOpen, props, close, saveBookmark, closeNotification, Notification }
}

})